export default __webpack_public_path__ + "static/images/cross.7cafc808.png";